import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isRepoAppEnabled() {
  return isFeatureEnabled('repo_app')
}

export function isAgentsEnabled() {
  return isRepoAppEnabled() && isFeatureEnabled('repo_app_agents')
}

export function isActionsWorkflowsEnabled() {
  return (
    isRepoAppEnabled() &&
    isFeatureEnabled('actions_workflows_react_toggle') &&
    isFeatureEnabled('repo_app_actions_workflows')
  )
}

export function isIssuesEnabled() {
  return isRepoAppEnabled() && isFeatureEnabled('repo_app_issues')
}

export function isPullRequestsEnabled() {
  return isRepoAppEnabled() && isFeatureEnabled('repo_app_pull_requests')
}

export function isCommitsEnabled() {
  return isRepoAppEnabled() && isFeatureEnabled('repo_app_commits')
}

export function isCodeViewEnabled() {
  return isRepoAppEnabled() && isFeatureEnabled('repo_app_code_view')
}

export function canSoftNavToCodeView() {
  return isCodeViewEnabled() && !isFeatureEnabled('ui_route_code_view')
}
